import {
  Component,
  inject,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { AuthService } from 'src/app/util/services/auth.service';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-profile',
  standalone: true,
  templateUrl: './help-profile.component.html',
  styleUrls: ['./help-profile.component.css'],
})
export class HelpProfileComponent {
  readonly parent = input.required<HelpComponent>();

  public _login = inject(AuthService);
}
